import { businessConnectionMst, common, mstCommon } from '@libs/domain';
import { mstListSearchFieldConfig, mstRegistrationFieldConfig } from '@libs/templates/mst';
import { Item } from '@ps-smart-cp/ppfw-client';

const businessConnectionMstRegistrationFieldConfig = {
  ...mstRegistrationFieldConfig,
  code: Item.of(mstCommon.names.code, businessConnectionMst.attributes.businessConnectionMstCode),
  businessConnectionClass: Item.of(
    businessConnectionMst.names.businessConnectionClass,
    businessConnectionMst.attributes.businessConnectionClass,
  ),
  eligibleBillingProvider: Item.of(
    common.names.eligibleBillingProvider,
    common.attributes.eligibleBillingProvider,
  ),
};

const businessConnectionMstListSearchFieldConfig = {
  ...mstListSearchFieldConfig,
  businessConnectionClass: Item.of(
    businessConnectionMst.names.businessConnectionClass,
    businessConnectionMst.attributes.businessConnectionClass.replaceRequired(false),
  ),
  eligibleBillingProviderCondition: Item.of(
    common.names.eligibleBillingProviderCondition,
    common.attributes.eligibleBillingProviderCondition,
  ),
};

const businessConnectionMstSettingFieldConfig = {
  codeDigits: Item.of(mstCommon.names.codeDigits, mstCommon.attributes.codeDigits),
};

export {
  businessConnectionMstListSearchFieldConfig,
  businessConnectionMstRegistrationFieldConfig,
  businessConnectionMstSettingFieldConfig,
};
